import { imagesBaseSrc, videosBaseSrc } from './constants'

import { EXTRA_LARGE_ICON_BASE_SRC, LARGE_ICON_BASE_SRC, SMALL_ICON_BASE_SRC, SMALL_MEDIUM_ICON_BASE_SRC, } from '../../../../../Shared'

// Centralized asset constants for onboarding tour
// All images and videos used across tour slides should be defined here
// And added to the relevant array at the bottom of the file for preloading

const tourBaseSrc = `${imagesBaseSrc}/pages/onboarding_slides`
const slidesBaseSrc = `${tourBaseSrc}/introduction`
const sharedSlidesBaseSrc = `${tourBaseSrc}/shared`
const englishLearnersBaseSrc = `${tourBaseSrc}/english_learners`
const socialStudiesBaseSrc = `${tourBaseSrc}/social_studies`

// Introduction slide assets
export const STUDENT_READING_ILLUSTRATION = `${slidesBaseSrc}/student_reading_illustration.svg`
export const QUILL_LOGO = `${sharedSlidesBaseSrc}/quill_logo.svg`
export const CHILD_RAISING_PENCIL = `${sharedSlidesBaseSrc}/child_raising_pencil.svg`
export const QUILL_CONNECT_BEZEL = `${slidesBaseSrc}/coral_reefs_in_bezel.svg`

// English learners slide assets
export const LANGUAGE_SELECTION_PAGE = `${englishLearnersBaseSrc}/language_selection_page@2x.png`
export const GRAMMAR_ACTIVITY_WITH_SPANISH_TRANSLATION = `${englishLearnersBaseSrc}/grammar_activity_with_spanish_translation@2x.png`
export const ELL_STARTER_SCREENSHOT = `${englishLearnersBaseSrc}/ell_starter_screenshot@2x.png`
export const ELL_INTERMEDIATE_SCREENSHOT = `${englishLearnersBaseSrc}/ell_intermediate_screenshot@2x.png`
export const ELL_ADVANCED_SCREENSHOT = `${englishLearnersBaseSrc}/ell_advanced_screenshot@2x.png`

// Social studies slide assets
export const BRITISH_WOMEN_WORKERS_EVIDENCE_ACTIVITY_ON_LAPTOP = `${socialStudiesBaseSrc}/british_women_workers_evidence_activity_on_laptop.svg`
export const COLD_WAR_AN_OVERVIEW_HEADER = `${socialStudiesBaseSrc}/cold_war_an_overview_header@2x.png`
export const EVIDENCE_ACTIVITY_SCREENSHOT = `${socialStudiesBaseSrc}/evidence_activity_screenshot@2x.png`
export const HOW_DID_BANANAS_LEAD_TO_A_COUP_IN_GUATEMALA_HEADER = `${socialStudiesBaseSrc}/how_did_bananas_lead_to_a_coup_in_guatemala_header@2x.png`
export const HOW_DID_HAITI_BECOME_THE_FIRST_INDEPENDENT_BLACK_REPUBLIC_HEADER = `${socialStudiesBaseSrc}/how_did_haiti_become_the_first_independent_black_republic_header@2x.png`
export const OER_PROJECT_ICON = `${socialStudiesBaseSrc}/oer_project_icon.svg`
export const OER_PROJECT_LOGO = `${socialStudiesBaseSrc}/oer_project_logo.svg`
export const QUILL_ICON = `${socialStudiesBaseSrc}/quill_icon.svg`
export const STUDENT_AND_TEACHER_ILLUSTRATION = `${socialStudiesBaseSrc}/student_and_teacher_illustration.svg`
export const SYNC_ICON = `${socialStudiesBaseSrc}/sync.svg`
export const TIMELINE = `${socialStudiesBaseSrc}/timeline@2x.png`
export const WHY_DID_FRANCE_INTERVENE_IN_THE_AMERICAN_REVOLUTION_HEADER = `${socialStudiesBaseSrc}/why_did_france_intervene_in_the_american_revolution_header@2x.png`
export const WHY_DID_REVOLUTIONS_ERUPT_THROUGH_THE_ATLANTIC_WORLD_HEADER = `${socialStudiesBaseSrc}/why_did_revolutions_erupt_through_the_atlantic_world_header@2x.png`

// Tour selection card icons
export const PENCIL_ICON = `${LARGE_ICON_BASE_SRC}/pencil.svg`
export const EARTH_ICON = `${LARGE_ICON_BASE_SRC}/earth.svg`
export const RESEARCH_BOOKS_ICON = `${LARGE_ICON_BASE_SRC}/research-books.svg`
export const SHIP_ICON = `${LARGE_ICON_BASE_SRC}/ship.svg`
export const FOUNTAIN_PEN_ICON = `${LARGE_ICON_BASE_SRC}/fountain-pen.svg`

// Shared slides assets
export const ACTIVITY_SUMMARY = `${sharedSlidesBaseSrc}/activity_summary@2x.png`
export const DIAGNOSTIC_ON_LAPTOP = `${imagesBaseSrc}/tools/diagnostic-on-laptop.svg`
export const EVIDENCE_ON_LAPTOP = `${imagesBaseSrc}/tools/evidence-on-laptop.svg`
export const GROWTH_DIAGNOSTIC_CLASS_SUMMARY = `${sharedSlidesBaseSrc}/growth_diagnostic_class_summary@2x.png`
export const TEACHER_READING_ILLUSTRATION = `${sharedSlidesBaseSrc}/teacher_reading_illustration.svg`
export const RECOMMENDATIONS_TABLE = `${sharedSlidesBaseSrc}/recommendations_table.svg`
export const KEN_ARROW = `${sharedSlidesBaseSrc}/ken_arrow.svg`
export const JASON_ARROW = `${sharedSlidesBaseSrc}/jason_arrow.svg`
export const QUILL_CONNECT_IMAGE = `${sharedSlidesBaseSrc}/quill_connect@2x.png`
export const QUILL_CONNECT_ARROW = `${sharedSlidesBaseSrc}/quill_connect_arrow.svg`
export const STUDENT_WAVING_ILLUSTRATION = `${sharedSlidesBaseSrc}/student_waving_illustration.svg`
export const EVIDENCE_HIGHLIGHT = `${sharedSlidesBaseSrc}/evidence_highlight.svg`
export const EVIDENCE_STEP_FIRST_ATTEMPT = `${sharedSlidesBaseSrc}/evidence_step_first_attempt.svg`
export const EVIDENCE_STEP_WITH_FEEDBACK = `${sharedSlidesBaseSrc}/evidence_step_with_feedback.svg`
export const FOOTBALL_PLAYERS = `${sharedSlidesBaseSrc}/football_players@2x.png`
export const CORAL_REEFS = `${sharedSlidesBaseSrc}/coral_reefs@2x.png`
export const WORLD_MAP = `${sharedSlidesBaseSrc}/world_map@2x.png`
export const STARTER_DIAGNOSTIC_SCREENSHOT = `${sharedSlidesBaseSrc}/starter_diagnostic_screenshot@2x.png`
export const INTERMEDIATE_DIAGNOSTIC_SCREENSHOT = `${sharedSlidesBaseSrc}/intermediate_diagnostic_screenshot@2x.png`
export const ADVANCED_DIAGNOSTIC_SCREENSHOT = `${sharedSlidesBaseSrc}/advanced_diagnostic_screenshot@2x.png`

// Tool icons (small/medium sizes)
export const TOOL_DIAGNOSTIC_BORDERED = `${SMALL_MEDIUM_ICON_BASE_SRC}/tool-diagnostic-bordered.svg`
export const TOOL_LESSONS_BORDERED = `${SMALL_MEDIUM_ICON_BASE_SRC}/tool-lessons-bordered.svg`
export const TOOL_CONNECT_BORDERED = `${SMALL_MEDIUM_ICON_BASE_SRC}/tool-connect-bordered.svg`
export const TOOL_PROOFREADER_BORDERED = `${SMALL_MEDIUM_ICON_BASE_SRC}/tool-proofreader-bordered.svg`
export const TOOL_GRAMMAR_BORDERED = `${SMALL_MEDIUM_ICON_BASE_SRC}/tool-grammar-bordered.svg`
export const TOOL_EVIDENCE_BORDERED = `${SMALL_MEDIUM_ICON_BASE_SRC}/tool-evidence-bordered.svg`

// Small icons
export const CHECKBOX_MULTI_ICON = `${SMALL_ICON_BASE_SRC}/checkbox-multi.svg`
export const CLOCK_ICON = `${SMALL_ICON_BASE_SRC}/clock.svg`
export const GRADUATION_CAP_ICON = `${SMALL_ICON_BASE_SRC}/graduation-cap.svg`

// Extra large icons
export const COMMENT_DOCUMENT_ICON = `${EXTRA_LARGE_ICON_BASE_SRC}/comment-document.svg`
export const RESEARCH_BOOKS_EXTRA_LARGE_ICON = `${EXTRA_LARGE_ICON_BASE_SRC}/research-books.svg`
export const SEARCH_DOCUMENT_ICON = `${EXTRA_LARGE_ICON_BASE_SRC}/search-document.svg`

// Video assets
export const ADMIN_ANIMATION_VIDEO = `${videosBaseSrc}/schools_and_districts/admin-animation.mov`
export const BATS_CONNECT_ACTIVITY_VIDEO = `${videosBaseSrc}/onboarding_slides/bats_connect_activity.mp4`
export const BRITISH_WOMEN_READING_FOR_EVIDENCE_VIDEO = `${videosBaseSrc}/onboarding_slides/british_women_reading_for_evidence.mp4`
export const BRITISH_WOMEN_WORKERS_EVIDENCE_ACTIVITY_ANIMATION = `${videosBaseSrc}/onboarding_slides/british_women_workers_evidence_activity_animation.mp4`
export const DIAGNOSTIC_ANIMATION_VIDEO = `${videosBaseSrc}/tools/diagnostic-animation.mov`
export const READING_FOR_EVIDENCE_ANIMATION_VIDEO = `${videosBaseSrc}/tools/reading-for-evidence-animation.mov`

// Full Quill logo
export const QUILL_FULL_LOGO = `${imagesBaseSrc}/logos/quill-logo-green.svg`

// Consolidated arrays for preloading
export const ALL_TOUR_IMAGES = [
  ACTIVITY_SUMMARY,
  ADVANCED_DIAGNOSTIC_SCREENSHOT,
  BRITISH_WOMEN_WORKERS_EVIDENCE_ACTIVITY_ON_LAPTOP,
  CHECKBOX_MULTI_ICON,
  CHILD_RAISING_PENCIL,
  CLOCK_ICON,
  COLD_WAR_AN_OVERVIEW_HEADER,
  COMMENT_DOCUMENT_ICON,
  CORAL_REEFS,
  DIAGNOSTIC_ON_LAPTOP,
  EARTH_ICON,
  ELL_ADVANCED_SCREENSHOT,
  ELL_INTERMEDIATE_SCREENSHOT,
  ELL_STARTER_SCREENSHOT,
  EVIDENCE_ACTIVITY_SCREENSHOT,
  EVIDENCE_HIGHLIGHT,
  EVIDENCE_ON_LAPTOP,
  EVIDENCE_STEP_FIRST_ATTEMPT,
  EVIDENCE_STEP_WITH_FEEDBACK,
  FOOTBALL_PLAYERS,
  FOUNTAIN_PEN_ICON,
  GRADUATION_CAP_ICON,
  GRAMMAR_ACTIVITY_WITH_SPANISH_TRANSLATION,
  GROWTH_DIAGNOSTIC_CLASS_SUMMARY,
  HOW_DID_BANANAS_LEAD_TO_A_COUP_IN_GUATEMALA_HEADER,
  HOW_DID_HAITI_BECOME_THE_FIRST_INDEPENDENT_BLACK_REPUBLIC_HEADER,
  INTERMEDIATE_DIAGNOSTIC_SCREENSHOT,
  JASON_ARROW,
  KEN_ARROW,
  LANGUAGE_SELECTION_PAGE,
  OER_PROJECT_ICON,
  OER_PROJECT_LOGO,
  PENCIL_ICON,
  QUILL_CONNECT_ARROW,
  QUILL_CONNECT_BEZEL,
  QUILL_CONNECT_IMAGE,
  QUILL_FULL_LOGO,
  QUILL_ICON,
  QUILL_LOGO,
  RECOMMENDATIONS_TABLE,
  RESEARCH_BOOKS_EXTRA_LARGE_ICON,
  RESEARCH_BOOKS_ICON,
  SEARCH_DOCUMENT_ICON,
  SHIP_ICON,
  STARTER_DIAGNOSTIC_SCREENSHOT,
  STUDENT_AND_TEACHER_ILLUSTRATION,
  STUDENT_READING_ILLUSTRATION,
  STUDENT_WAVING_ILLUSTRATION,
  SYNC_ICON,
  TEACHER_READING_ILLUSTRATION,
  TIMELINE,
  TOOL_CONNECT_BORDERED,
  TOOL_DIAGNOSTIC_BORDERED,
  TOOL_EVIDENCE_BORDERED,
  TOOL_GRAMMAR_BORDERED,
  TOOL_LESSONS_BORDERED,
  TOOL_PROOFREADER_BORDERED,
  WHY_DID_FRANCE_INTERVENE_IN_THE_AMERICAN_REVOLUTION_HEADER,
  WHY_DID_REVOLUTIONS_ERUPT_THROUGH_THE_ATLANTIC_WORLD_HEADER,
  WORLD_MAP,
]

export const ALL_TOUR_VIDEOS = [
  ADMIN_ANIMATION_VIDEO,
  BATS_CONNECT_ACTIVITY_VIDEO,
  BRITISH_WOMEN_READING_FOR_EVIDENCE_VIDEO,
  DIAGNOSTIC_ANIMATION_VIDEO,
  READING_FOR_EVIDENCE_ANIMATION_VIDEO,
]
